export const DEFAULT_PAGE_SIZES = [10, 20, 30, 40, 60, 80, 100];
